<template>
    <div>
        <activix-banner
            color="orange-400"
            :dismissable="false"
            v-if="
                (impersonating && !$wait.is('auth.impersonating')) ||
                $wait.is('auth.unimpersonating')
            "
        >
            <template v-if="$wait.is('auth.unimpersonating')">
                <span class="font-semibold truncate">
                    {{ $t('banner.impersonation.endingSession') }}
                    <div class="relative | inline-flex">
                        <icon class="ml-1 text-sm spin-inverse" :name="$icons.loading" />
                    </div>
                </span>
            </template>
            <template v-else>
                <span class="font-semibold truncate">
                    {{ $t('banner.impersonation.title', [`${impersonatedUser.fullName}`]) }}
                </span>

                <activix-tooltip
                    :content="$t('banner.impersonation.tooltip', [`${impersonatedUser.fullName}`])"
                >
                    <icon class="text-sm ml-1 shrink-0" name="regular/information-circle" />
                </activix-tooltip>

                <div class="ml-5 flex items-center group absolute right-4">
                    <a class="md:ml-2 text-white font-bold" @click="emitLogout()">
                        <icon class="mr-1" name="regular/logout-1" />
                        {{ $t('banner.impersonation.exit') }}
                    </a>
                </div>
            </template>
        </activix-banner>
    </div>
</template>

<script>
    import { useEventBus } from '@/hooks/useEventBus.ts';
    import { useUserStore } from '@/store/modules/user/store.js';
    import User from '@/entities/User.js';

    const { emit } = useEventBus();

    export default {
        computed: {
            User() {
                return User;
            },
            impersonatedUser() {
                return useUserStore().parentAuthUser;
            },
            impersonating() {
                return this.$auth.impersonating();
            },
        },

        methods: {
            emitLogout() {
                emit('logout');
            },
        },
    };
</script>
